import React, { useEffect, useState } from "react";
import ReportsDetailPage from "./index"
import { useNavigate, useParams } from "react-router";
import { Iconography, IconographySizes } from "@hid-galaxy-ui/galaxy-react";
import { axiosRestInstance } from "../../../../../common/axios";
import { useAppSelector } from "../../../../../redux";
import { postJoinedTablesFieldsDataType } from "../../../../../redux/saga/partner-details";

type SelectedCategory = {
  key: string;
  title: string;
  description: string;
};

const ReportsDetailParent: React.FC = () => {
    const { categoryKey } = useParams<{ categoryKey: string }>();
    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState<SelectedCategory | null>(null);
    const [loadingCategory, setLoadingCategory] = useState<boolean>(!!categoryKey);
    const [loadingCategories, setLoadingCategories] = useState<boolean>(false); // NEW LOADING STATE FOR CATEGORIES
    const [categoriesCount, setCategoriesCount] = useState<number | null>(null);

    const { reportFilter } : {reportFilter: postJoinedTablesFieldsDataType}= useAppSelector(state => state.partner_details);
    const fetchCategories = async () => {
        try {
          setLoadingCategories(true);
          const response = await axiosRestInstance.get("/category/all");
          setCategoriesCount(response.data.length);
        } catch (error) {
          console.error("Error fetching categories:", error);
          setCategoriesCount(0);
        } finally {
          setLoadingCategories(false); // ALWAYS reset
        }
      };

    useEffect(() => {
        if (!categoryKey) {
          setSelectedCategory(null);
          setLoadingCategory(false);
    
          // FETCH categories immediately when coming to listing page
          fetchCategories();
          return;
        }
        else {
          const fetchCategory = async () => {
            setLoadingCategory(true);
            try {
              const response = await axiosRestInstance.get(`/category/${categoryKey}`);
              const fetchedCategory: SelectedCategory = {
                title: response.data.data.name || "Untitled Category",
                description: response.data.data.description || "",
                key: String(response.data.data.ID),
              };
              setSelectedCategory(fetchedCategory);
            } catch (error: any) {
              if (error.response?.status === 404) {
                navigate("/hid-admin/dashboard/reports-dashboard");
              } else {
                console.error("Failed to fetch category:", error);
              }
            } finally {
              setLoadingCategory(false);
            }
          };
    
          fetchCategory();
        }
        
      }, [categoryKey]);

  return (
    <>
        <div className="gdl-root gdl-reports__container">
            {categoryKey && selectedCategory && (
            <nav className="gdl-breadcrumbs">
                <button
                className="gdl-breadcrumbs__link"
                title="Go to Dashboard"
                onClick={() => {
                    setSelectedCategory(null);
                    navigate("/hid-admin/dashboard/reports-dashboard");
                }}
                >
                Dashboard
                </button>
                <Iconography icon="angleRight" size={IconographySizes.Small} />
                <button
                className="gdl-breadcrumbs__link"
                onClick={() => navigate(`/hid-admin/dashboard/reports-dashboard/category/${selectedCategory.key}`)}
                >
                {selectedCategory.title} Reports
                </button>
                <>
                    <Iconography icon="angleRight" size={IconographySizes.Small} />
                    <span className="gdl-breadcrumbs__current">{reportFilter.report_title}</span>
                </>
            
            </nav>
            )}
            <ReportsDetailPage />
        </div>
    </>
  )
   
};

export default ReportsDetailParent;
